"use strict";
exports.__esModule = true;
exports["default"] = function(instance) {
  instance.registerHelper("lookup", function(obj, field, options) {
    if (!obj) {
      return obj;
    }
    return options.lookupProperty(obj, field);
  });
};
module.exports = exports["default"];
